import {
  Box,
  Button,
  ChevronRightIcon,
  Flex,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';

import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

import type { BrandSpecial } from '../JaneGoldCallout/JaneGoldCallout.types';
import { Modal } from '../Modal';
import styles from './CompleteBundleModal.module.css';

interface CompleteBundleCardProps extends Pick<
  CompleteBundleModalProps,
  'onClick' | 'userSignedIn'
> {
  bundle: BrandSpecial;
}

export interface CompleteBundleModalProps {
  bundlesInProgress: BrandSpecial[];
  onClick?: (bundle: BrandSpecial) => void;
  onRequestClose: () => void;
  open: boolean;
  userSignedIn?: boolean;
}

export const CompleteBundleCard = ({
  bundle,
  onClick,
  userSignedIn,
}: CompleteBundleCardProps) => {
  const isSegmentedDeal =
    brandSpecialOrProductHasSegments({
      brandSpecial: bundle,
    }) && !userSignedIn;

  return (
    <Flex
      className={styles['boxShadow']}
      aria-label={`Complete your ${bundle.title} bundle`}
      flexDirection="row"
      borderRadius="lg"
      p={24}
      mb={24}
      alignItems="center"
      onClick={() => onClick?.(bundle)}
    >
      <PartnerLogo
        variant="brand"
        size="md"
        name={bundle.product_brand?.name || ''}
        image={bundle.product_brand?.logo_url}
      />
      <Flex flexDirection="column" ml={32} mr={40} overflow="hidden">
        <Typography variant="body-bold" branded truncateAt="100%">
          {bundle.product_brand?.name} • Bundle
        </Typography>
        <Typography maxLines={2}>{bundle.title}</Typography>
        {isSegmentedDeal && (
          <Typography color="grays-mid">(Sign in for eligibility)</Typography>
        )}
      </Flex>
      <Box ml="auto">
        <ChevronRightIcon size="md" />
      </Box>
    </Flex>
  );
};

export const CompleteBundleModal = ({
  bundlesInProgress,
  onClick,
  onRequestClose,
  open,
  userSignedIn,
}: CompleteBundleModalProps) => {
  return (
    <Modal
      appId="root"
      contentLabel="Complete Bundle"
      onRequestClose={onRequestClose}
      open={open}
      overflow="visible"
      variant="dialogue"
    >
      <Modal.Content overflowY="auto" padding={false}>
        <Flex width="520px" flexDirection="column" p={32}>
          <Typography variant="title-bold" mb={56}>
            Complete bundle
          </Typography>
          {bundlesInProgress.map((bundle) => (
            <CompleteBundleCard
              key={bundle.id}
              bundle={bundle}
              onClick={onClick}
              userSignedIn={userSignedIn}
            />
          ))}
          <Button
            full
            branded
            variant="tertiary"
            label="Cancel"
            onClick={onRequestClose}
            mt={8}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
